import { render, staticRenderFns } from "./edit-documentos.vue?vue&type=template&id=35d51f85"
import script from "./edit-documentos.vue?vue&type=script&lang=ts"
export * from "./edit-documentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports